import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import { Button } from "antd";

interface LinkButtonProps {
  to: string;
  children: ReactNode;
  disabled?: boolean;
  style?: React.CSSProperties;
}

const LinkButton: FC<LinkButtonProps> = ({ to, children, disabled, style }) => {
  return (
    <Link to={to} style={{ textDecoration: "none" }}>
      <Button disabled={disabled} style={style}>
        {children}
      </Button>
    </Link>
  );
};

export default LinkButton;
